import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Typography,
    Grid,
    IconButton,
    Menu,
    MenuItem,
    Badge,
    Modal,
    Avatar,
    Stack,
    Button,
    Popover,
    List, Drawer,
    ListItem, Divider, useMediaQuery, useTheme
} from "@mui/material";
import {
    Notifications,
    CalendarToday,
    Close, Menu as MenuIcon
} from "@mui/icons-material";
import Back from '../../../assets/Back.png';
import { HomeWork, Work, Checklist, AccessTime, Event, EmojiEvents, AccountBalance } from '@mui/icons-material';
// import Home from '../backups/Home';
import EmployeeCards from "./EmployeeCards";
import MyProjectsDashboard from '../Projects/EmployeeProjects';
import MyTasks from '../Tasks/MyTasks';
import EmployeeAttendance from '../Attendance/EmployeeAttendance';
import EmployeeLeaveManagement from '../Leaves/EmployeeLeaveManagement';
import EmployeeApparisals from '../Performance/EmployeeApparisals';
import Payroll from '../Payroll';
import hrmsDashboardImage from "../../../assets/Hrms_Hashstack.png";
import AttendanceTimerWithoutTimers from '../../../components/AttendanceTimerWithoutTimers';
import EditProfile from '../../../components/EditProfile';
import axios from "axios";
import { localAxiosGet, axiosInstance } from "../../../Axios/axios";
import TokenExpirePopup from "../../../components/TokenExpirePopup";
import PushNotificationManager from "../../../components/PushNotificationPrompt";

const menuItems = [
    { name: 'Home', icon: <HomeWork />, component: <EmployeeCards /> },
    { name: 'My Projects', icon: <Work />, component: <MyProjectsDashboard /> },
    { name: 'My Tasks', icon: <Checklist />, component: <MyTasks /> },
    { name: 'My Attendance', icon: <AccessTime />, component: <EmployeeAttendance /> },
    { name: 'My Leaves', icon: <Event />, component: <EmployeeLeaveManagement /> },
    { name: 'My Performance', icon: <EmojiEvents />, component: <EmployeeApparisals /> },
    { name: 'Payroll', icon: <AccountBalance />, component: <Payroll /> },
];

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: 800,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: 8,
};

const EmployeeDashboard = () => {
    const [currentView, setCurrentView] = useState("Home");
    const [notifications, setNotifications] = useState([]);
    const [notificationCount, setNotificationCount] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const currentDate = new Date().toLocaleDateString();
    const [status, setStatus] = useState('OUT');
    const navigate = useNavigate();
    const accessToken = localStorage.getItem('accessToken');
    const userId = localStorage.getItem('userId');
    const [userDetails, setUserDetails] = useState('');
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [showNotificationPrompt, setShowNotificationPrompt] = useState(false);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const response = await axiosInstance(localAxiosGet(`/organization/getUserDetailsByUserId?userId=${userId}`, accessToken));
                console.log("API Response:", response.data);
                if (response.data.status === "SUCCESS") {
                    setUserDetails(response.data.message.user);
                    // localStorage.setItem('userDetailsStorage', JSON.stringify(response.data.message.user));
                    console.log('userDetails', userDetails);
                }

            } catch (error) {
                console.log('Error in Fetching User details', error);

                if (error.response && error.response.status === 403) {
                    setOpenTokenExpirePopup(true);
                }
            }
        };

        fetchUserDetails();
    }, []);

    useEffect(() => {
        const fetchNotificationCount = async () => {
            if (!userId) return;

            try {
                const response = await axiosInstance(
                    localAxiosGet(`/notifications/count?user_id=${userId}`)
                );

                if (response.data.status === "SUCCESS") {
                    setNotificationCount(response.data.message.count);
                }

            } catch (error) {
                console.log("Error fetching notification count:", error);
            }
        };

        fetchNotificationCount();
        const intervalId = setInterval(fetchNotificationCount, 30 * 60 * 1000);

        return () => clearInterval(intervalId);
    }, [userId]);



    const fetchNotifications = async () => {
        if (!userId) return;

        try {
            const response = await axiosInstance(
                localAxiosGet(`/notifications/getNotifications?userId=${userId}`)
            );

            if (response.data.status === "SUCCESS") {
                setNotifications(response.data.message);
            }

        } catch (error) {
            console.log("Error fetching notifications:", error);
        }
    };


    const markNotificationAsRead = async (notificationId) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${axiosInstance.defaults.baseURL}/notifications/mark-read`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                data: {
                    notification_ids: [notificationId]
                }
            });

            if (response.data.status === "SUCCESS") {

                setNotifications(prevNotifications =>
                    prevNotifications.map(notification =>
                        notification.id === notificationId
                            ? { ...notification, is_read: true, read_at: new Date().toISOString() }
                            : notification
                    )
                );


                setNotificationCount(prevCount => Math.max(0, prevCount - 1));
            }
        } catch (error) {
            console.log('Error marking notification as read:', error);
        }
    };

    function capitalizeFirstChar(str) {
        if (!str) return "";
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const handleSignOutButton = () => {
        navigate('/');
    };


    const handleNotificationClick = (event) => {
        setAnchorEl(event.currentTarget);
        fetchNotifications();
    };


    const handleNotificationClose = () => {
        setAnchorEl(null);
    };


    const handleNotificationItemClick = (notificationId, isRead) => {
        if (!isRead) {
            markNotificationAsRead(notificationId);
        }
    };


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };


    const getSenderName = (notification) => {

        if (notification.sender_name) {
            return notification.sender_name;
        }


        if (notification.sender_first_name && notification.sender_last_name) {
            return `${capitalizeFirstChar(notification.sender_first_name)} ${capitalizeFirstChar(notification.sender_last_name)}`;
        }


        return notification.sender_type;
    };


    const getSenderInitials = (notification) => {

        if (notification.sender_first_name && notification.sender_last_name) {
            return `${notification.sender_first_name.charAt(0)}${notification.sender_last_name.charAt(0)}`;
        }


        if (notification.sender_name) {
            const nameParts = notification.sender_name.split(' ');
            if (nameParts.length > 1) {
                return `${nameParts[0].charAt(0)}${nameParts[1].charAt(0)}`;
            }
            return notification.sender_name.charAt(0);
        }


        return notification.sender_type.charAt(0);
    };

    const handleMenuItemClick = (menuName) => {
        setCurrentView(menuName);
    };

    const handleBackClick = () => {
        setCurrentView("Home");
    };

    const renderContent = () => {
        const selectedMenuItem = menuItems.find((item) => item.name === currentView);
        if (selectedMenuItem) {

            if (selectedMenuItem.name === 'Home') {

                return React.cloneElement(selectedMenuItem.component, { onCardSelect: setCurrentView });
            }
            return selectedMenuItem.component;
        }
        return <EmployeeCards onCardSelect={setCurrentView} />;
    };
    const handleOpenEditDialog = () => {
        setOpenEditDialog(true);
    };

    const handleCloseEditDialog = () => {
        setOpenEditDialog(false);
    };

    const handleCloseTokenExpirePopup = () => {
        setOpenTokenExpirePopup(false);
        navigate('/');
    };

    const open = Boolean(anchorEl);
    const id = open ? 'notification-popover' : undefined;

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpenDrawer(open);
    };

    const handleDrawerMenuItemClick = (menuName) => {
        setCurrentView(menuName);
        setOpenDrawer(false);
    };


    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', width: '100vw', overflowX: 'hidden' }}>
            {/* Main sidebar and content */}
            <Box
                sx={{
                    display: 'flex',

                    flexDirection: {
                        xs: 'column',
                        md: 'row'
                    },
                    width: '100%'
                }}
            >
                {/* Sidebar */}
                <Box
                    sx={{
                        width: {
                            xs: "100%",
                            md: "15%"
                        },
                        height: 'auto',
                        backgroundColor: "#2C3E50",
                        color: "#ECF0F1",
                        p: { xs: 2, md: 2 },
                        display: { xs: 'none', md: 'flex' },
                        flexDirection: { xs: 'column', md: 'column' },
                        alignItems: { xs: 'center', md: 'flex-start' },
                        pb: { xs: 2, md: 0 }
                    }}
                >
                    <Box sx={{ textAlign: "center", mb: { xs: 2, md: 3 } }}>
                        <img
                            src={hrmsDashboardImage}
                            alt="HRMS Dashboard"
                            style={{ width: "60%", height: "auto", maxWidth: "120px", margin: "0 auto" }}
                        />
                    </Box>
                    <Stack spacing={1.5} sx={{ width: '100%' }}>
                        {menuItems.map((item) => (
                            <Button
                                key={item.name}
                                onClick={() => handleMenuItemClick(item.name)}
                                startIcon={item.icon}
                                sx={{
                                    justifyContent: "flex-start",
                                    color: currentView === item.name ? "#FFFFFF" : "#BDC3C7",
                                    backgroundColor: currentView === item.name ? "#2980B9" : "transparent",
                                    padding: "10px 15px",
                                    borderRadius: 1,
                                    textTransform: "none",
                                    width: { xs: '100%', md: 'auto' },
                                    '&:hover': {
                                        backgroundColor: "#3b5998",
                                        color: "#FFFFFF",
                                    },
                                }}
                            >
                                {item.name}
                            </Button>
                        ))}
                    </Stack>
                </Box>

                {/* Main Content */}
                <Box
                    sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: "#ECF0F1",
                        minHeight: { xs: 'calc(100vh - auto)', md: '100vh' },
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xs: 'column', sm: 'row' },
                            justifyContent: { xs: 'center', sm: 'space-between' },
                            alignItems: { xs: 'center', sm: 'center' },
                            p: { xs: "15px 20px", sm: "10px 35px" },
                            bgcolor: "#2B3C4E",
                            color: "#ECF0F1",
                            gap: { xs: 2, sm: 0 },
                        }}
                    >
                        {/* Logo for small screens */}

                        <Box
                            sx={{
                                display: "flex",
                                gap: 2,
                                flexDirection: { xs: 'column', sm: 'row' },
                                alignItems: 'center',
                                textAlign: { xs: 'center', sm: 'left' },
                                order: { xs: 0, sm: 0 },
                            }}
                        >
                            {isSmallScreen && (
                                <Box sx={{ order: { xs: 0 } }}>
                                    <img
                                        src={hrmsDashboardImage}
                                        alt="HRMS Logo"
                                        style={{ width: "50px", height: "auto" }}
                                    />
                                </Box>
                            )}
                            <Box sx={{ order: { xs: 1 } }}>
                                <Typography variant="h6" fontWeight="bold" sx={{ mb: { xs: 1, sm: 0.5 }, fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                                    Welcome Back, {`${capitalizeFirstChar(userDetails.first_name)} ${capitalizeFirstChar(userDetails.last_name)}`}
                                </Typography>
                                <Typography display='flex' alignItems='center' sx={{ justifyContent: { xs: 'center', sm: 'flex-start' } }}>
                                    <CalendarToday fontSize="small" sx={{ mr: 1 }} />{currentDate}
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: { xs: 1, sm: 2 },
                            flexDirection: { xs: 'column', sm: 'row' },
                            order: { xs: 2, sm: 2 }
                        }}>
                            <IconButton
                                sx={{ display: { xs: 'block', md: 'none' }, color: '#FFFFFF' }}
                                onClick={toggleDrawer(true)}
                                aria-label="open drawer"
                            >
                                <MenuIcon />
                            </IconButton>

                            {/* Drawer for the slide-down menu */}
                            <Drawer
                                anchor="top"
                                open={openDrawer}
                                onClose={toggleDrawer(false)}
                                sx={{
                                    '& .MuiDrawer-paper': {
                                        width: '100%',
                                        boxSizing: 'border-box',
                                        bgcolor: '#2C3E50',
                                        color: '#ECF0F1',
                                        marginTop: '80px',
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        textAlign: 'end',
                                        mr: 4,
                                        pt: 1
                                    }}
                                >
                                    <IconButton onClick={toggleDrawer(false)} sx={{ color: '#ECF0F1' }}>
                                        <Close />
                                    </IconButton>
                                </Box>
                                <List sx={{ width: '100%', pt: 0 }}>
                                    {menuItems.map((item) => (
                                        <ListItem
                                            button
                                            key={item.name}
                                            onClick={() => handleDrawerMenuItemClick(item.name)}
                                            sx={{
                                                px: 3,
                                                py: 2,
                                                color: currentView === item.name ? "#FFFFFF" : "#BDC3C7",
                                                backgroundColor: currentView === item.name ? "#2980B9" : "transparent",
                                                '&:hover': {
                                                    backgroundColor: "#3b5998",
                                                    color: "#FFFFFF",
                                                },
                                            }}
                                        >
                                            {item.icon}
                                            <Typography sx={{ ml: 2, }}>{item.name}</Typography>
                                        </ListItem>
                                    ))}

                                </List>
                            </Drawer>


                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <AttendanceTimerWithoutTimers status={status} setStatus={setStatus} />
                            </Box>
                            {userId && <PushNotificationManager userId={userId} />}
                            <IconButton
                                onClick={handleNotificationClick}
                                aria-describedby={id}
                            >
                                <Badge
                                    badgeContent={notificationCount}
                                    color="error"
                                    sx={{
                                        '& .MuiBadge-badge': {
                                            backgroundColor: '#ff0000',
                                            color: 'white',
                                            fontWeight: 'bold'
                                        }
                                    }}
                                >
                                    <Notifications sx={{ color: "#FFFFFF" }} />
                                </Badge>
                            </IconButton>

                            {/* Notification Popover - width adjustment */}
                            <Popover
                                id={id}
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleNotificationClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                PaperProps={{
                                    style: {
                                        width: '350px',
                                        maxWidth: 'calc(100vw - 40px)',
                                        maxHeight: '450px',
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                        overflow: 'hidden'
                                    }
                                }}
                            >
                                <Box sx={{ p: 2, bgcolor: '#3498DB', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
                                            Notifications
                                        </Typography>
                                        <IconButton size="small" sx={{ color: 'white' }} onClick={handleNotificationClose}>
                                            <Close fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </Box>

                                <List sx={{ p: 0, maxHeight: '400px', overflowY: 'auto' }}>
                                    {notifications.length === 0 ? (
                                        <Box sx={{ p: 3, textAlign: 'center' }}>
                                            <Typography variant="body1" color="textSecondary">
                                                No notifications to display
                                            </Typography>
                                        </Box>
                                    ) : (
                                        notifications.map((notification, index) => (
                                            <React.Fragment key={notification.id}>
                                                <ListItem
                                                    button
                                                    alignItems="flex-start"
                                                    onClick={() => handleNotificationItemClick(notification.id, notification.is_read)}
                                                    sx={{
                                                        p: 2,
                                                        backgroundColor: notification.is_read ? 'white' : '#dbeafe',
                                                        transition: 'background-color 0.3s',
                                                        borderLeft: notification.is_read ? 'none' : '4px solid #3498DB',
                                                        '&:hover': {
                                                            backgroundColor: notification.is_read ? '#f9f9f9' : '#bfdbfe'
                                                        }
                                                    }}
                                                >
                                                    <Box sx={{ display: 'flex', width: '100%' }}>
                                                        <Box
                                                            sx={{
                                                                width: 40,
                                                                height: 40,
                                                                borderRadius: '50%',
                                                                bgcolor: '#3498DB',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                color: 'white',
                                                                fontWeight: 'bold',
                                                                mr: 2
                                                            }}
                                                        >
                                                            {getSenderInitials(notification)}
                                                        </Box>
                                                        <Box sx={{ flex: 1 }}>
                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#2c3e50' }}>
                                                                    {getSenderName(notification)}
                                                                </Typography>
                                                                <Typography variant="caption" color="textSecondary">
                                                                    {formatDate(notification.createdAt)}
                                                                </Typography>
                                                            </Box>
                                                            <Typography variant="body2" sx={{
                                                                color: '#34495e',
                                                                fontWeight: notification.is_read ? 'normal' : 'medium'
                                                            }}>
                                                                {notification.message}
                                                            </Typography>
                                                            <Typography variant="caption" sx={{ color: '#7f8c8d', mt: 0.5, display: 'block' }}>
                                                                Type: {notification.type.replace(/_/g, ' ')}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </ListItem>
                                                {index < notifications.length - 1 && <Divider />}
                                            </React.Fragment>
                                        ))
                                    )}
                                </List>
                            </Popover>

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    backgroundColor: "#1ABC9C",
                                    borderRadius: 2,
                                    p: 1,
                                    color: "#FFFFFF",
                                    width: { xs: '100%', sm: 'auto' },
                                    justifyContent: { xs: 'center', sm: 'flex-start' }
                                }}
                            >
                                {status}
                            </Box>
                            <Box
                                sx={{ width: '50px', height: '50px', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                onClick={handleOpenEditDialog}
                            >
                                <Avatar
                                    sx={{
                                        bgcolor: "#0D47A1",
                                        width: 40,
                                        height: 40,
                                        fontSize: '1rem',
                                        fontWeight: 'bold',
                                        borderRadius: "50%"
                                    }}
                                >
                                    {userDetails.first_name?.charAt(0).toUpperCase()}
                                    {userDetails.last_name?.charAt(0).toUpperCase()}
                                </Avatar>
                            </Box>
                            {/* Edit Profile Modal */}
                            <Modal open={openEditDialog} onClose={handleCloseEditDialog}>
                                <Box sx={modalStyle}>
                                    <EditProfile onClose={handleCloseEditDialog} />
                                </Box>
                            </Modal>
                        </Box>
                    </Box>
                    {/* Main Content Area */}
                    <Box sx={{
                        flex: 1,
                        bgcolor: "#f9f9f9",
                        pt: { xs: 2, md: 4 },
                        pl: { xs: 2, md: 4 },
                        pr: { xs: 2, md: 2 },
                        pb: { xs: 2, md: 6 },
                        overflowY: 'auto'
                    }}>
                        {currentView !== "Home" && (
                            <Box
                                onClick={handleBackClick}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    mb: { xs: 1, md: 2 },
                                    justifyContent: { xs: 'flex-start', md: 'flex-start' }
                                }}
                            >
                                <img
                                    src={Back}
                                    alt="Back to Dashboard"
                                    style={{ width: "30px", height: "30px", marginRight: "10px" }}
                                />
                                <Typography>Back to Dashboard</Typography>
                            </Box>
                        )}
                        {renderContent()}
                    </Box>
                </Box>
            </Box>
           
            
        </Box>
    );
};

export default EmployeeDashboard;